import { Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerOverlay, 
    Flex, Grid, IconButton, Stack, Text, useDisclosure, SimpleGrid, GridProps } from "@chakra-ui/react";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import { Tooltip } from "@mui/material";

export default function Sidebar(props){
    let location = useLocation();
    const { logo, logoAxsis, routes, colorMode, hamburguerColor, ...rest } = props;

    const [state, setState] = React.useState({});
    const container = React.useRef();

    const activeRoute = (routeName) => {
        return location.pathname === routeName ? "active" : "";
    };

    let activeBg = "white";
    let inactiveBg = "white";
    let activeColor = "gray.700";
    let inactiveColor = "gray.400";
    let sidebarBackgroundColor = "white";

    const createLinks = (routes) => {
        return routes.map((prop, key) => {
            return(
                    <NavLink to={prop.layout + prop.path} key={key} className="linksTo">
                        {activeRoute(prop.layout + prop.path) === "active" ? (
                            <Button
                                boxSize="initial"
                                justifyContent="flex-start"
                                alignItems="center"
                                bg={activeBg}
                                boxShadow={"0px 7px 11px rgba(0,0,0,0.04)"}
                                mb={{xl: "6px"}}
                                mx={{xl: "auto"}}
                                ps="16px"
                                py="12px"
                                borderRadius="15px"
                                w="100%"
                                _active={{bg: "inherit", transform: "none", borderColor: "transparent"}}
                                _focus={{boxShadow:"none"}}>
                                    <Flex>
                                        <IconButton
                                            fontSize={"1.3rem"}
                                            bg={"blue"}
                                            color={"white"}
                                            h="30px"
                                            w="30px"
                                            me="12px"
                                            icon={prop.icon}
                                            borderRadius={"8px"}
                                            alignItems="center"
                                            justifyContent={"center"}/>
                                        <Text color={activeColor} my="auto" fontSize="sm">
                                            {prop.name}
                                        </Text>
                                    </Flex>
                            </Button>
                        ) : (
                            <Button className="btnMenu"
                                boxSize="initial"
                                justifyContent="flex-start"
                                alignItems="center"
                                bg="transparent"
                                mb={{xl: "6px"}}
                                mx={{xl: "auto"}}
                                ps="16px"
                                py="12px"
                                borderRadius="15px"
                                w="100%"
                                _active={{bg: "inherit", transform: "none", borderColor: "transparent"}}
                                _focus={{boxShadow: "none"}}>
                                    <Flex>
                                        <IconButton
                                            fontSize={"1.3rem"}
                                            bg={inactiveBg}
                                            color={"blue"}
                                            h="30px"
                                            w="30px"
                                            me="12px"
                                            icon={prop.icon}
                                            borderRadius={"8px"}
                                            alignItems="center"
                                            justifyContent={"center"}/>
                                        <Text color={inactiveColor} my="auto" fontSize="sm">
                                            {prop.name}
                                        </Text>
                                    </Flex>
                                
                            </Button>
                        )}
                    </NavLink>
               
            );
        });
    };

    var links = (createLinks(routes));

    var brandR = (
        <>
            <Flex
                h="100%"
                w="1px"
                bg="linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #E0E1E2 49.52%, rgba(224,225,226,0) 100%)">
            </Flex>
            <Box pt={"10px"} mb="8px" display={'flex'} alignItems={'center'}>
                {logoAxsis}
            </Box>
        </>
    );

    var brand = (
        <>
        <Box pt={"10px"} mb="8px" display={'flex'} alignItems={'center'}>
            {logo}
        </Box>
        <Flex
            h="100%"
            w="1px"
            bg="linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #E0E1E2 49.52%, rgba(224,225,226,0) 100%)">
        </Flex>
        
        </>
    );

    const { isOpen, onOpen, onClose } = useDisclosure();
    const btnRef = React.useRef();

    return(
        <Flex
            ref={container}
            alignItems="center">
                <Tooltip title="Menú">
                    <MenuIcon sx={{color: hamburguerColor, cursor: 'pointer', fontSize: '1.3rem'}} ref={btnRef} onClick={onOpen}/>
                </Tooltip>
                <Drawer isOpen={isOpen} onClose={onClose} placement="top" finalFocusRef={btnRef} >
                    <DrawerOverlay className="drawer-overlay"/>
                    <DrawerContent w="100%" ms={{sm: "16px"}} my={{sm: "16px"}} bg={sidebarBackgroundColor}>
                        <DrawerCloseButton _focus={{boxShadow: "none"}} _hover={{boxShadow: "none"}} sx={{position: "absolute", top: "0.5rem", right:"0.75rem"}}/>
                        <DrawerBody maxW="100%" px="1rem">
                            <Flex maxW="100%"  >
                                <Box flexDirection={"row"} display="flex">{brand}</Box>
                                <Stack h={"100%"} w={"100%"} px={"30px"} py={"30px"}>
                                    {/* <Grid templateColumns='repeat(6, 1fr)' gap={16}>
                                        {links}
                                    </Grid> */}
                                    <SimpleGrid className="gridLinks" spacing={10}>
                                        {links}
                                    </SimpleGrid >
                                </Stack>
                                <Box flexDirection={"row"} display="flex">{brandR}</Box>
                            </Flex>
                        </DrawerBody>
                    </DrawerContent>
                </Drawer>
        </Flex>
    );

}